import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import SignUp from 'components/SignUp/SignUp';

export default class SignUpPage extends Component {
  static propTypes = {
    signUp: PropTypes.func,
    location: PropTypes.object,
  };

  render() {
    const { location } = this.props;
    const queryType = location && location.query && location.query.type;
    const defaultAccountType =
      queryType === 'seller' || queryType === 'buyer' ? queryType : undefined;

    return (
      <div key="signup" id="this">
        <Helmet title="Sign Up" />
        <SignUp
          redirect={'onboarding'}
          redirectFromGoogle={'signup'}
          layout="progressive"
          defaultAccountType={defaultAccountType}
        />
      </div>
    );
  }
}
